import * as z from 'zod'

export const flatPageSchema = z.object({
  content: z.string(),
  dateFrom: z.string().optional().nullable(),
  description: z.string(),
  firstPhoto: z.string().optional().nullable(),
  firstPhotoDescription: z.string().optional().nullable(),
  metaKeywords: z.string(),
  title: z.string(),
  breadcrumbs: z
    .array(
      z.object({
        title: z.string(),
        url: z.string(),
      }),
    )
    .optional(),
  hreflangs: z
    .array(
      z.object({
        code: z.string(),
        url: z.string(),
        hreflang: z.string(),
      }),
    )
    .optional(),
  languages: z.array(z.string()).optional(),
})

export type FlatPage = z.infer<typeof flatPageSchema>
